import * as PasswordResetActionTypes from '../actionTypes/PasswordResetActionTypes';

export const resetPassword = (email) => ({
    type: PasswordResetActionTypes.PASSWORD_RESET,
    payload: email,
});

export const setPassword = (params) => ({
    type: PasswordResetActionTypes.PASSWORD_SET,
    payload: params,
});

export const getAccountEmail = (params) => ({
    type: PasswordResetActionTypes.GET_ACCOUNT_EMAIL,
    payload: params,
});

export const forgotPasswordAnalyticsAction = () => ({
    type: PasswordResetActionTypes.FORGOT_PASSWORD_ANALYTICS,
});

export const forgotPasswordSuccessAction = () => ({
    type: PasswordResetActionTypes.FORGOT_PASSWORD_SUCCESS,
});

export const setPasswordFormError = (errors) => ({
    type: PasswordResetActionTypes.PASSWORD_SET_FORM_ERROR,
    payload: errors,
});

export const resetPasswordSliderState = () => ({
    type: PasswordResetActionTypes.RESET_PASSWORD_SLIDER_STATE,
});

export const requestOtpToResetPassword = (
    { phoneNumber, isReSendRequest = false },
    isSignInSliderReq
) => ({
    type: PasswordResetActionTypes.POST_REQUEST_OTP_TO_RESET_PASSWORD,
    payload: { phoneNumber, isReSendRequest, isSignInSliderReq },
});

export const verifyOtpToResetPassword = ({ phoneNumber, otp }) => ({
    type: PasswordResetActionTypes.VERIFY_OTP_TO_RESET_PASSWORD,
    payload: { phoneNumber, otp },
});

export const setNewPasswordUsingPhoneNumber = ({ phoneNumber, otp, password }) => ({
    type: PasswordResetActionTypes.SET_NEW_PASSWORD_USING_PHONE_NUMBER,
    payload: { phoneNumber, otp, password },
});

export const passwordResetByPhoneInitiatedAnalytics = (eventName) => ({
    type: PasswordResetActionTypes.PASSWORD_RESET_BY_PHONE_INITIATED,
    eventName,
});
